import { render, staticRenderFns } from "./admin-nav.vue?vue&type=template&id=bd813ace&"
import script from "./admin-nav.ts?vue&type=script&lang=ts&"
export * from "./admin-nav.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports